export { default } from './Pricing';



// WEBPACK FOOTER //
// ./src/components/templates/Pricing/index.js